<template>
  <router-link
    :to="'/' + product.prefix"
    class="a-horizontal bg-image-v"
    :class="[categoryType]"
    :style="bgImageObj"
  >
    <h3 :class="[pPosition]" class="title color-text">
      {{ product.name }}
    </h3>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeProductComponent',
  props: {
    product: {
      type: Object,
      required: true
    },
    isShortTitleBg: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      bgImageObj: {
        backgroundImage:
          'url(' +
          require('../assets/productpage/segments/backgrounds/' +
            this.product.imageFileName) +
          ')'
      },
      pPosition: this.isShortTitleBg ? 'p-short-bg' : 'p-long-bg'
    };
  },
  computed: {
    ...mapGetters({
      activeCategories: 'activeCategories'
    }),
    categoryType() {
      // A category can be inactive only if there are other categories in the array
      if (!this.activeCategories.length) {
        return 'active';
      }
      return !this.activeCategories.includes(this.product.name)
        ? 'inactive'
        : 'active';
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

/* Declarations */
@section-font-weight: 600;
@border-width: 4 / @px;
@section-font-weight: 800;
@horizontal-title-width: (100vw / 8.5);

.bg-image-v {
  background-size: cover;
  box-sizing: border-box;
  background-origin: content-box;
  background-position: center center;
}

.title {
  background-color: fade(@gray-05, 70%);
  margin: 0;
}
.p-short-bg {
  padding: @space-medium;
  width: @horizontal-title-width;
}

.p-long-bg {
  display: flex;
  align-items: center;
  padding: @space-medium;
  width: auto;
}

.a-horizontal {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

.inactive {
  opacity: 0.3;
  pointer-events: none;
}
</style>
